/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.transcripts.rpc.AcademyTranscriptsRpc
 */

export const checkCaptionsExistRpc = {
  serviceName: 'com.hubspot.academy.transcripts.rpc.AcademyTranscriptsRpc',
  rpcName: 'checkCaptionsExist',
  auth: 'app',
  fingerprint: 'vcywff5LlLSt46gqs7axyqXek2WwwLw8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};